/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EdiDeliveryProtocol } from "./EdiDeliveryProtocol";
import {
  EdiDeliveryProtocolFromJSON,
  EdiDeliveryProtocolFromJSONTyped,
  EdiDeliveryProtocolToJSON,
  EdiDeliveryProtocolToJSONTyped,
} from "./EdiDeliveryProtocol";
import type { EdiInvoiceSendTiming } from "./EdiInvoiceSendTiming";
import {
  EdiInvoiceSendTimingFromJSON,
  EdiInvoiceSendTimingFromJSONTyped,
  EdiInvoiceSendTimingToJSON,
  EdiInvoiceSendTimingToJSONTyped,
} from "./EdiInvoiceSendTiming";

/**
 *
 * @export
 * @interface SaveEdiDeliverySettingsRequest
 */
export interface SaveEdiDeliverySettingsRequest {
  /**
   *
   * @type {string}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  companyId: string;
  /**
   *
   * @type {EdiDeliveryProtocol}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  protocol: EdiDeliveryProtocol;
  /**
   *
   * @type {string}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  host: string;
  /**
   *
   * @type {number}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  port: number;
  /**
   *
   * @type {string}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  password?: string | null;
  /**
   *
   * @type {string}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  directory: string;
  /**
   *
   * @type {string}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  trackingDirectory?: string | null;
  /**
   *
   * @type {EdiInvoiceSendTiming}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  invoiceSendTiming: EdiInvoiceSendTiming;
  /**
   *
   * @type {boolean}
   * @memberof SaveEdiDeliverySettingsRequest
   */
  enabled: boolean;
}

/**
 * Check if a given object implements the SaveEdiDeliverySettingsRequest interface.
 */
export function instanceOfSaveEdiDeliverySettingsRequest(
  value: object,
): value is SaveEdiDeliverySettingsRequest {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (!("protocol" in value) || value["protocol"] === undefined) return false;
  if (!("host" in value) || value["host"] === undefined) return false;
  if (!("port" in value) || value["port"] === undefined) return false;
  if (!("username" in value) || value["username"] === undefined) return false;
  if (!("directory" in value) || value["directory"] === undefined) return false;
  if (
    !("invoiceSendTiming" in value) ||
    value["invoiceSendTiming"] === undefined
  )
    return false;
  if (!("enabled" in value) || value["enabled"] === undefined) return false;
  return true;
}

export function SaveEdiDeliverySettingsRequestFromJSON(
  json: any,
): SaveEdiDeliverySettingsRequest {
  return SaveEdiDeliverySettingsRequestFromJSONTyped(json, false);
}

export function SaveEdiDeliverySettingsRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SaveEdiDeliverySettingsRequest {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    protocol: EdiDeliveryProtocolFromJSON(json["protocol"]),
    host: json["host"],
    port: json["port"],
    username: json["username"],
    password: json["password"] == null ? undefined : json["password"],
    directory: json["directory"],
    trackingDirectory:
      json["trackingDirectory"] == null ? undefined : json["trackingDirectory"],
    invoiceSendTiming: EdiInvoiceSendTimingFromJSON(json["invoiceSendTiming"]),
    enabled: json["enabled"],
  };
}

export function SaveEdiDeliverySettingsRequestToJSON(
  json: any,
): SaveEdiDeliverySettingsRequest {
  return SaveEdiDeliverySettingsRequestToJSONTyped(json, false);
}

export function SaveEdiDeliverySettingsRequestToJSONTyped(
  value?: SaveEdiDeliverySettingsRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    protocol: EdiDeliveryProtocolToJSON(value["protocol"]),
    host: value["host"],
    port: value["port"],
    username: value["username"],
    password: value["password"],
    directory: value["directory"],
    trackingDirectory: value["trackingDirectory"],
    invoiceSendTiming: EdiInvoiceSendTimingToJSON(value["invoiceSendTiming"]),
    enabled: value["enabled"],
  };
}
